import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import CancelOrReissueCardPopup from 'apps/auth/components/ga/cards/details/CancelOrReissueCardPopup';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { AUTH_GA_CARD, AUTH_GA_STUB_PAGE, AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { LINK, requestsReissueCard, SUCCESS } from 'apps/auth/services/GaCardsService';

const ExpiredNotificationPage = (props) => {
    const { notNowButton, reopenExpiredButton, subtitleExpired, titleExpired, messageCardActivated, cancelPlasticCardButton } = usePageMessages();
    const { card = {}, showVirtualPreview = false } = useExtra();
    const [screen, setScreen] = useState(LINK);
    const popupRef = useRef(null);

    const topButtonLink = card?.plastic && showVirtualPreview ? `${AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW}?fromReissue=true` : AUTH_SEND_MAIN_LINK;

    const onClickSuccess = () => {
        window.location.href = AUTH_GA_CARD + card?.id;
    };
    return (
        <>
            <BaseLayout showChat={false}>
                {screen === SUCCESS ? (
                    <ModalWithTimer text={messageCardActivated} onClick={onClickSuccess} />
                ) : (
                    <InfoPage
                        iconName={'card-alert-80'}
                        iconColor={'primary'}
                        headerText={<DangerouslyHtml dangerouslyHtml={titleExpired} />}
                        secondaryText={subtitleExpired}
                        primaryButtonCaption={card?.plastic ? cancelPlasticCardButton : reopenExpiredButton}
                        primaryButtonType="link"
                        primaryButtonLink={AUTH_GA_STUB_PAGE + '?linkForNotNow=' + AUTH_SEND_MAIN_LINK}
                        primaryButtonOnClick={(e) => {
                            if (card?.virtual) {
                                e.preventDefault();
                                requestsReissueCard(card, props.toggleSpinner, props.addExtras, setScreen);
                            } else {
                                e.preventDefault();
                                popupRef.current?.open(<CancelOrReissueCardPopup agree={true} popupRef={popupRef} />);
                            }
                        }}
                        topButtonCaption={notNowButton}
                        topButtonType="link"
                        topButtonLink={topButtonLink}
                    />
                )}
            </BaseLayout>
            <PopupNew ref={popupRef} />
        </>
    );
};
export default connect(null, { addExtras, toggleSpinner })(BasePage(ExpiredNotificationPage));
